<script>
    import Background from './components/background.svelte';
    import Preloader from './components/preloader.svelte';
    import Sidebar from './components/sidebar.svelte';
    import Pages from './pages';

    import store from './state';
    import getTransition from './transitions';
    let transition = $state({});

    function onPrevPageChange(prevPage) {
        if (!prevPage) return;

        let t = getTransition($store.transition);

        let n = {};
        n[prevPage] = t.outClass;
        n[$store.page] = t.inClass;

        transition = n;
    }

    function onTransitionEnd(e, key) {
        delete transition[key];

        if (key === $store.prevPage) {
            $store.prevPage = null;
        }
    }

    let pageIndexes = {};
    let i = 0;
    for (let page of Pages) {
        pageIndexes[page.key] = i;
        i++;
    }

    let page = $state(null);
    function pageChanged(key) {
        let index = pageIndexes[key];
        page = Pages[index];
    }

    $effect(() => {
        onPrevPageChange($store.prevPage)
        pageChanged($store.page);
    });
</script>

<style>
    .content-area {
        position: absolute;
        right: 0;
        background-color: transparent;
        height: 100%;
        width: 100%;
        max-width: calc(100% - 380px);
    }

    .animated-sections {
        position: relative;
        height: 100%;
        -webkit-perspective: 1500px;
        -moz-perspective: 1500px;
        perspective: 1500px;
        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        backface-visibility: hidden;
    }

    .animated-section {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: absolute;
        background-color: #222;
        height: 100%;
        width: 100%;
        border-radius: 30px;
        padding: 60px;
        opacity: 0;
        overflow: auto;
        visibility: hidden;
        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-transform: translate3d(0, 0, 0);
        -moz-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
        background-repeat: no-repeat;
        background-position: center;
        background-position: 50% 50%;
        background-size: cover;
    }

    .section-active {
        opacity: 1;
        overflow: auto;
        visibility: visible;
        z-index: 99;
    }

    .section-active::-webkit-scrollbar {
        width: 30px;
    }

    .section-active::-webkit-scrollbar-track, .section-active::-webkit-scrollbar-thumb {
        border-radius: 0 30px 30px 0;
    }

    .section-active::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    }

    .section-active::-webkit-scrollbar-thumb {
        background: #1d1d1d;
    }

    .page-title {
        display: inline-block;
        position: relative;
        padding-right: 25px;
        padding-bottom: 15px;
        margin-bottom: 30px;
    }

    .page-title h1 {
        position: relative;
        font-size: 32px;
        z-index: 1;
    }

    /* .page-title h2 span {
        color: #5050f5;
    } */

    .page-title:after {
        position: absolute;
        opacity: 0.45;
        top: 10px;
        right: 0;
        content: '';
        height: 30px;
        width: 50px;
        background-image: -webkit-repeating-radial-gradient(center center, #5050f5, #5050f5 1px, transparent 0px, transparent 100%);
        background-image: -moz-repeating-radial-gradient(center center, #5050f5, #5050f5 1px, transparent 0px, transparent 100%);
        background-image: -ms-repeating-radial-gradient(center center, #5050f5, #5050f5 1px, transparent 0px, transparent 100%);
        -webkit-background-size: 6px 6px;
        -moz-background-size: 6px 6px;
        background-size: 6px 6px;
        z-index: 0;
    }

    .section-content {
        width: 100%;
        flex: 1;
    }

    @media only screen and (max-width: 1280px) {
        .page {
            padding-left: 30px;
        }

        .content-area {
            max-width: calc(100% - 330px);
        }
    }

    @media only screen and (max-width: 1024px) {
        .page {
            padding: 0;
        }

        .page-content {
            padding: 0;
            margin: 0;
            border-radius: 0;
            min-height: 100%;
        }

        .content-area {
            max-width: 100%;
        }

        .animated-section {
            border-radius: 0;
            padding: 20px 30px 20px 20px;
            overflow: auto !important;
        }

        .section-active::-webkit-scrollbar {
           width: 20px;
        }

        .section-active::-webkit-scrollbar-track, .section-active::-webkit-scrollbar-thumb {
            border-radius: 0;
        }
    }
</style>

<svelte:head>
    {#if page && page.title}
        <title>Venty.cz - {page.title}</title>
    {:else}
        <title>Venty.cz</title>
    {/if}
</svelte:head>

<Background />
<Preloader />

<div class="page">
    <div class="page-content">
        <Sidebar />

        <div class="content-area">
            <div class="animated-sections">
                {#each Pages as page}
                    <section data-id={page.key}
                             class={`animated-section ${transition[page.key] || ''}`} class:section-active={page.key === $store.page || page.key === $store.prevPage}
                             onanimationend={(e) => onTransitionEnd(e, page.key)}>
                        {#if page.title && page.title.length}
                            <div class="page-title">
                                <h1>{page.title}</h1>
                            </div>
                        {/if}

                        <div class="section-content">
                            <page.cmp />
                        </div>
                    </section>
                {/each}
            </div>
        </div>
    </div>
</div>
